import Text from 'components/base/Text';
import { StyledSyncGitTeamsForm } from './SyncGitTeamsForm.style';
import TeamsPicker from './TeamsPicker';
import ContributorsView from './ContributorsView/ContributorsView';
import TotalSummary from './TotalSummary/TotalSummary';
import _ from 'lodash';
import { StyledWizardFooter } from '../SyncGitTeamsWizard.style';
import { LBButton } from '@linearb/buzz';

const SyncGitTeamsForm = ({
  orgName,
  providerTeams,
  selectedTeam,
  onClickTeam,
  toggleTeamCheckbox,
  isTeamChecked,
  isTeamChildChecked,
  total,
  isLoading,
  isError,
  checkedTeams,
  onNext = _.noop,
  onBack = _.noop
}) => {
  const isTeamSelected = !!selectedTeam;
  const isNextButtonDisabled =
    !!isError || !!isLoading || _.size(providerTeams) === 0;

  return (
    <StyledSyncGitTeamsForm>
      <Text size='x-medium' mt='1rem'>
        Select a GitHub team - we’ll keep all contained contributors and teams
        up-to-date in LinearB
      </Text>
      <main className='teams-form'>
        {!isError && (
          <TeamsPicker
            teams={providerTeams}
            selectedTeam={selectedTeam}
            onClickTeam={onClickTeam}
            toggleTeamCheckbox={toggleTeamCheckbox}
            isTeamChecked={isTeamChecked}
            isTeamChildChecked={isTeamChildChecked}
            orgName={orgName}
          />
        )}
        {isTeamSelected && (
          <ContributorsView
            selectedTeam={selectedTeam}
            onCancel={() => onClickTeam(null)}
          />
        )}
      </main>
      <TotalSummary total={total} isLoading={isLoading} isError={isError} />
      <StyledWizardFooter>
        <LBButton
          variant='outline'
          size='lg'
          onClick={onBack}
          data-cy='SyncGitTeamsForm-btn-back'
        >
          Back
        </LBButton>
        <LBButton
          size='lg'
          data-cy='SyncGitTeamsForm-btn-save'
          disabled={isNextButtonDisabled}
          onClick={() => onNext(checkedTeams)}
        >
          Next
        </LBButton>
      </StyledWizardFooter>
    </StyledSyncGitTeamsForm>
  );
};

export default SyncGitTeamsForm;
